export enum StatusTextColor {
  RED = 'red',
}